import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Row, Col, Typography, Spin, Input, Button, notification } from 'antd';
import './RoomTypeModal.css';

const { Text } = Typography;

@inject('RoomTypeStore')
@observer
class RoomTypeModalPage extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    componentDidMount() {
    }

    // ON CLICK

    createOrUpdateRoomTypeOnClick = () => {
        const { roomTypeId } = this.props.RoomTypeStore;
        if (roomTypeId === 0) {
            this.props.RoomTypeStore.createRoomType().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Room type has been successfully created.',
                        duration: 3
                    });
                    this.props.RoomTypeStore.initRoomType();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        } else {
            this.props.RoomTypeStore.updateRoomType().then(response => {
                if (!response.isError) {
                    notification['success']({
                        message: 'Success',
                        description: 'Room type has been successfully updated.',
                        duration: 3
                    });
                    this.props.RoomTypeStore.initRoomType();
                } else {
                    notification['error']({
                        message: 'Error',
                        description: response.errorMessage,
                        duration: 3
                    });
                }
            });
        }
    }

    render() {
        const {
            roomTypeName,
            roomTypeTextButton,
            roomTypeModalLoading
        } = this.props.RoomTypeStore;

        let addOrUpdateRoomTypeDisable = false;
        if (roomTypeName === '') {
            addOrUpdateRoomTypeDisable = true;
        }

        return (
            <Spin spinning={roomTypeModalLoading}>
                <Row className='roomtypemodal-row-container'>
                    <Col span={24} className='roomtypemodal-col'>
                        <Row>
                            <Col span={8} className='roomtypemodal-col-label'>
                                <Text className='roomtypemodal-text-label'>Room Type<Text className='roomtypemodal-text-label-mandatory'>*</Text></Text>
                            </Col>
                            <Col span={16} className='roomtypemodal-col-input'>
                                <Input value={roomTypeName} onChange={(e) => this.props.RoomTypeStore.setRoomTypeName(e.target.value)} />
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} className='roomtypemodal-col-button'>
                        <Button disabled={addOrUpdateRoomTypeDisable} type='primary' className='roomtypemodal-button' onClick={this.createOrUpdateRoomTypeOnClick}>{roomTypeTextButton}</Button>
                    </Col>
                </Row>
            </Spin >
        )
    }
}

export default RoomTypeModalPage;